"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _ButtonWithLoader = _interopRequireDefault(require("../Buttons/ButtonWithLoader"));
var _excluded = ["children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SubmitButton = function SubmitButton(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? "Submit" : _ref$children,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useFormikContext = (0, _formik.useFormikContext)(),
    dirty = _useFormikContext.dirty,
    isSubmitting = _useFormikContext.isSubmitting;
  return /*#__PURE__*/_react["default"].createElement(_ButtonWithLoader["default"], _extends({
    type: "submit",
    disabled: isSubmitting || !dirty,
    showLoader: isSubmitting
  }, other), children);
};
SubmitButton.propTypes = {
  /** Text for the button. Will default to "Submit" */
  children: _propTypes["default"].node
};
var _default = exports["default"] = SubmitButton;